<template>
    <svg width="158" height="113" viewBox="0 0 158 113" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M136.697 56.2584C136.697 85.6722 112.852 109.517 83.4381 109.517C54.0243 109.517 30.1797 85.6722 30.1797 56.2584C30.1797 26.8446 54.0243 3 83.4381 3C96.6544 3 108.746 7.81402 118.056 15.7842C129.466 25.5523 136.697 40.0609 136.697 56.2584Z" fill="#2A8176"/>
            <circle cx="149.124" cy="11.8764" r="8.8764" fill="#B6DBC4"/>
            <circle cx="5.32584" cy="54.4831" r="5.32584" fill="#2A8176"/>
            <path d="M76.6195 104.056C106.781 104.056 131.233 79.6074 131.233 49.4488C131.233 41.0866 129.353 33.1634 125.993 26.0787C132.706 34.8223 136.696 45.7653 136.696 57.6402C136.696 86.2909 113.468 109.517 84.8137 109.517C72.9416 109.517 62.0009 105.53 53.2578 98.8216C60.3405 102.178 68.2607 104.056 76.6195 104.056Z" fill="white"/>
        <path d="M62.1196 7.4382C68.6473 4.58367 75.8578 3 83.4381 3C96.6544 3 108.746 7.81402 118.056 15.7842C129.466 25.5523 136.697 40.0609 136.697 56.2584C136.697 70.7046 130.945 83.8074 121.607 93.4017C111.931 103.342 98.4058 109.517 83.4381 109.517C54.0243 109.517 30.1797 85.6722 30.1797 56.2584C30.1797 45.9572 33.1043 36.339 38.1685 28.189" stroke="#073B5D" stroke-width="5.32584" stroke-linecap="round" stroke-linejoin="round"/>
        <g clip-path="url(#clip0_36_4725)">
            <path d="M74.5004 66.815L62.6854 55L58.6621 58.995L74.5004 74.8333L108.5 40.8333L104.505 36.8383L74.5004 66.815Z" fill="white"/>
        </g>
        <defs>
            <clipPath id="clip0_36_4725">
                <rect width="68" height="68" fill="white" transform="translate(49 21)"/>
            </clipPath>
        </defs>
    </svg>
</template>

<script setup>
</script>
